import {
    Button, Card, CardContent, CardHeader, CircularProgress, Divider, Grid, IconButton, List, ListItem,
    Typography,
    ExpansionPanelDetails, TableContainer, ExpansionPanelSummary, Table, TableBody, TableRow, TableCell, Badge, ExpansionPanel
  } from '@material-ui/core';
  import { makeStyles } from '@material-ui/styles';
  import clsx from 'clsx';
  import PropTypes from 'prop-types';
  import React, { Fragment, useEffect, useState } from 'react';
  import { useTranslation } from 'react-i18next';
  import { connect, useSelector } from 'react-redux';
  import axios from 'src/utils/axios';
  import { getUser } from 'src/utils/Common';
  import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
  import { MdPhonelinkSetup } from 'react-icons/md';
  import { VscFilePdf } from 'react-icons/vsc';
  import { FaRegFileWord } from 'react-icons/fa';
  import { RiFileExcel2Line } from 'react-icons/ri';
  import { BiImage } from 'react-icons/bi';
  import { GrDocumentZip } from 'react-icons/gr';
  import ErrorMessage from 'src/components/ErrorMessage';
  import Paper from '@material-ui/core/Paper';
  import CloseIcon from "@material-ui/icons/Close";
  import OpenInNewIcon from '@material-ui/icons/OpenInNew';
  import GetAppIcon from '@material-ui/icons/GetApp';

  const useStyles = makeStyles((theme) => ({
    root: {},
    contentB: {
      minHeight: 430,
    },
    dividerB: {
      backgroundColor: '#1D3343'
    },
    dialogHeader: {
      cursor: 'move',
      backgroundColor: theme.palette.primary.main,
      padding: theme.spacing(1),
      color: theme.palette.common.white,
      textAlign: 'center',
      fontWeight: 'bold',
      position: 'relative',
      zIndex: 10,
    },
    dialogContent: {
      padding: theme.spacing(2),
      backgroundColor: theme.palette.background.paper,
    },
    iframe: {
      width: '100%',
      height: '600px',
      border: 'none',
    },
    zipContent: {
      padding: theme.spacing(2),
      textAlign: 'center',
    },
    unknownContent: {
      padding: theme.spacing(2),
      color: theme.palette.error.main,
      textAlign: 'center',
    },
    actionButtons: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: theme.spacing(1),
      marginBottom: theme.spacing(2),
    }
  }));
  
  function Bulten({
    className, ProductModelCode,onClose 
  }) {
    const classes = useStyles();
    const { t } = useTranslation('work_order');
    const [BulletinData, setBulletinData] = useState([]);
    const SessionUser = getUser();
    const ServiceShopCode = SessionUser.ServiceShopId;
    const TechnicianCode = SessionUser.TechnicianId;
    const [Loading, setLoading] = useState(true);
    const [expanded, setExpanded] = useState(false);
    const Model = ProductModelCode ? ProductModelCode : '';
    const isOnline = useSelector((state) => state.status?.isOnline);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [fileType, setFileType] = useState('');
    const [fileContent, setFileContent] = useState(null);
    const [iframeHeight, setIframeHeight] = useState(600);

    useEffect(() => {
        const handleResize = () => {
        if (window.innerWidth < 600) {
            setIframeHeight(400);
        } else {
            setIframeHeight(600);
        }
        };

        window.addEventListener('resize', handleResize);
        handleResize(); 

        return () => window.removeEventListener('resize', handleResize);
    }, []);

  
    useEffect(() => {
      let mounted = true;
      const fetchTodos = () => {
        let ModelParam = '-1';
        if (Model !== '') {
          ModelParam = Model;
        }
        axios.get(`/GetSiriusBulletin/1/${ServiceShopCode}/${TechnicianCode}/${ModelParam}`).then((response) => {
          if (mounted) {
            const value = response.data === '' ? [] : response.data;
            setBulletinData(value);
            setLoading(false);
          }
        }).catch((error) => {
          setLoading(false);
        });
      };
      fetchTodos();
      return () => {
        mounted = false;
      };
    }, [ServiceShopCode, TechnicianCode, Model]);
  
    const OpenBulletinDetail = (log) => {
      setLoading(true);
      const dataBulettin = {
        ServiceShopId: SessionUser.ServiceShopId,
        UserId: SessionUser.UserId,
        FilePtr: log.StreamId,
      };
      const config = {
        responseType: 'blob',
        headers: { 'Content-Type': 'application/json' }
      };
  
      axios.post('/FileImportExport/SiriusBulletin', dataBulettin, config)
        .then((response) => {
          const file = new Blob([response.data], { type: response.headers['content-type'] });
          const fileURL = URL.createObjectURL(file);
  
          setFileType(response.headers['content-type']);
          setFileContent(fileURL);
          setSelectedDocument(log);
        })
        .catch((error) => {
          console.error(t('lblFileError') + ':', error);
          alert(t('lblFileError2'));
        })
        .finally(() => {
          setLoading(false);
        });
    };
  
    const handleGoBack = () => {
      setSelectedDocument(null);
      setFileContent(null);
    };

    const handleOpenInNewTab = () => {
      window.open(fileContent, '_blank');
    };

    const handleDownload = () => {
      const link = document.createElement('a');
      link.href = fileContent;
      link.download = selectedDocument.StreamName;
      link.click();
    };
  
  
    const renderSwitch = (param) => {
      switch (param) {
        case 'image/bmp': return <BiImage />;
        case 'image/jpeg': return <BiImage />;
        case 'image/gif': return <BiImage />;
        case 'application/pdf': return <VscFilePdf />;
        case 'application/x-zip-compressed': return <GrDocumentZip />;
        case 'application/msword': return <FaRegFileWord />;
        case 'application/vnd.ms-excel': return <RiFileExcel2Line />;
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': return <RiFileExcel2Line />;
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': return <RiFileExcel2Line />;
        case 'application/x-msdownload': return <MdPhonelinkSetup />;
        case 'application/unknown': return <MdPhonelinkSetup />;
        case 'application/octet-stream': return <MdPhonelinkSetup />;
        default: return <MdPhonelinkSetup />;
      }
    };
  
    const handleChange = (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
    };
  
    return (
      <div>
        {selectedDocument ? (
          <Card className={clsx(classes.root, className)}>
          <CardHeader
          title={selectedDocument.StreamName}
          action={
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <Button onClick={handleGoBack} color="primary">
                {t('lblBack')}
              </Button>
              <IconButton
                color="primary"
                onClick={onClose}
                aria-label="close"
                component="span"
              >
                <CloseIcon />
              </IconButton>
            </div>
          }
        />
            <Divider />
            <CardContent className={classes.contentB}>
                <div className={classes.actionButtons}>
                    {fileType === 'application/pdf' && (
                    <Grid container spacing={2} justifyContent="flex-end">
                        <Grid item xs={12} sm={6} md={4} lg={6}>
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            startIcon={<OpenInNewIcon />}
                            onClick={handleOpenInNewTab}
                        >
                            {t('OpeninNewTab')}
                        </Button>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={6}>
                        <Button
                            fullWidth
                            variant="contained"
                            color="secondary"
                            startIcon={<GetAppIcon />}
                            onClick={handleDownload}
                        >
                            {t('Download')}
                        </Button>
                        </Grid>
                    </Grid>
                )}
            </div>
              {fileType.startsWith('image/') && (
                <img src={fileContent} alt="image" style={{ width: '100%' }} />
              )}
              {fileType === 'application/pdf' && (
              <iframe
                src={fileContent}
                className={classes.iframe}
                style={{ height: iframeHeight }}
                title="PDF Preview"
              ></iframe>
            )}
              {fileType.startsWith('text/') && (
                <iframe src={fileContent} className={classes.iframe} title="Text Preview"></iframe>
              )}
              {(fileType === 'application/msword' || fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') && (
                <iframe src={fileContent} className={classes.iframe} title="Word Preview"></iframe>
              )}
              {(fileType === 'application/vnd.ms-excel' || fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') && (
                <iframe src={fileContent} className={classes.iframe} title="Excel Preview"></iframe>
              )}
              {fileType === 'application/x-zip-compressed' && (
                <div className={classes.zipContent}>
                  <Typography>Zip</Typography>
                </div>
              )}
              {fileType === 'application/unknown' && (
                <div className={classes.unknownContent}>
                  <Typography>{t('lblUnknownMsg')}</Typography>
                </div>
              )}
            </CardContent>
          </Card>
        ) : (
          <Card className={clsx(classes.root, className)}>
            <CardHeader title={t('lblLibrary')} action={
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <IconButton
                    color="primary"
                    onClick={onClose}
                    aria-label="close"
                    component="span"
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
              }/>
            <Divider />
            <CardContent className={classes.contentB}>
              {isOnline ? (
                <Fragment>
                  <div className={classes.inner}>
                    {Loading
                      ? (
                        <CircularProgress
                          status="loading"
                          style={{ marginLeft: '50%' }}
                        />
                      )
                      : BulletinData.map((log) => (
                        <ExpansionPanel key={log.DocumentType} expanded={expanded === log.DocumentTypeId} onChange={handleChange(log.DocumentTypeId)}>
                          <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                          >
                            <Typography className={classes.secondaryHeading}>
                              {log.DocumentType}
                              <IconButton aria-label="cart">
                                <Badge badgeContent={log.Documents.length} color="secondary" />
                              </IconButton>
                            </Typography>
                          </ExpansionPanelSummary>
                          <ExpansionPanelDetails>
                            <TableContainer component={Paper}>
                              <Table className={classes.table} aria-label="simple table">
                                <TableBody>
                                  {log.Documents.map((row) => (
                                    <TableRow
                                      key={row.DocumentId}
                                    >
                                      <TableCell
                                        component="th"
                                        onClick={(e) => OpenBulletinDetail(row)}
                                        scope="row"
                                      >
                                        <IconButton aria-label="cart">
                                          {renderSwitch(row.StreamMimeType)}
                                        </IconButton>
                                        {row.StreamName}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </ExpansionPanelDetails>
                        </ExpansionPanel>
                      ))}
                  </div>
                </Fragment>
              ) : (
                <ErrorMessage message={t('Offline_Message')} />
              )}
            </CardContent>
          </Card>
        )}
      </div>
    );
  }
  
  Bulten.propTypes = {
    className: PropTypes.string
  };
  
  export default connect(
    (state) => ({ tasks: state.tasks1 })
  )(Bulten);